import {Scale, ScaleVisualization} from '~src/interfaces/scale.interface';
import llsLogger from "~src/services/logger/LlsLogger";

export function calcStarsIndex(averageRating: number): number {
  const roundedNumber = Math.ceil((averageRating - 0.2499) * 10);
  return roundedNumber < 0 ? 0 : Math.abs(roundedNumber);
}

export function getScaleLength(scale: Scale): number {
  switch (scale.visualization) {
    case ScaleVisualization.Stars:
      return 5;
    case ScaleVisualization.Labels:
      return scale.labels.length;
    case ScaleVisualization.Nps:
      return 11;
    case ScaleVisualization.McqOptions:
      llsLogger.warn(`getting length for MCQ Options scale ${scale.id}(${JSON.stringify(scale.name)})`);
      return 5;
    default:
      return 5;
  }
}

export function calcLabelIndex(averageRating: number, scale: Scale): number {
  const maxRating = getScaleLength(scale);
  const smallestRating = 3 / (maxRating * 2) - 1 / 1000;
  const roundedNumber = Math.ceil(((averageRating - smallestRating) * (maxRating * 2)) / 2);
  return roundedNumber < 0 ? 0 : Math.abs(roundedNumber);
}

export function getIndexScaleLength(scale: Scale): number {
  switch (scale.visualization) {
    case ScaleVisualization.Stars:
      return 10;
    case ScaleVisualization.Labels:
      return scale.labels.length;
    case ScaleVisualization.Nps:
      return 11;
    case ScaleVisualization.McqOptions:
      return scale.multipleChoiceOptions.length;
    default:
      return 5;
  }
}

export function calcNPSIndex(averageRating: number): number {
  const smallestRating = 3 / (11 * 2) - 1 / 1000;
  const roundedNumber = Math.ceil(((averageRating - smallestRating) * (11 * 2)) / 2);
  return roundedNumber < 0 ? 0 : Math.abs(roundedNumber);
}

export function calcTwoDigitsRating(maxRating: number, rating: number, type: ScaleVisualization): number {
  if (type === ScaleVisualization.Nps) {
    return Math.round(maxRating * rating * 100 - 100) / 100;
  }

  return Math.round(maxRating * rating * 100) / 100;
}

/**
 * reverse calculation from reporting, see ConvertRatingOrd
 *  `(*card.Answer+1) / (scaleVersion.Denominator + 1)`
 *
 * this sucks, as it is **not** working with the authoritative data from backend, where scale_version.denominator determines the max index (and thus length) of the given scale
 * @param averageRating
 * @param scale
 */
export function calcIndex(averageRating: number | null | undefined, scale: Scale | null | undefined): number {
  if (!scale) {
    return 0;
  }
  if (averageRating) {
    switch (scale.visualization) {
      case ScaleVisualization.Stars: {
        return calcStarsIndex(averageRating);
      }
      case ScaleVisualization.Labels: {
        return calcLabelIndex(averageRating, scale);
      }
      case ScaleVisualization.Nps: {
        return calcNPSIndex(averageRating);
      }
      default: {
        return calcStarsIndex(averageRating);
      }
    }
  }
  return 0;
}
